import { render, staticRenderFns } from "./DocumentUploadForm.vue?vue&type=template&id=3be0288e&scoped=true&"
import script from "./DocumentUploadForm.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0288e",
  null
  
)

export default component.exports